import {
	KC_ID_TOKEN_KEY,
	KC_REFRESH_TOKEN_KEY,
	TOKEN_KEY,
} from '@constants/local-storage.constant';

export interface StoredKeycloakSession {
	token?: string;
	refreshToken?: string;
	idToken?: string;
}

export interface KeycloakUserClaims {
	email?: string;
	fullName?: string;
	name?: string;
	given_name?: string;
	family_name?: string;
	preferred_username?: string;
}

export function readStoredKeycloakSession(): StoredKeycloakSession {
	return {
		token: localStorage.getItem(TOKEN_KEY) ?? undefined,
		refreshToken: localStorage.getItem(KC_REFRESH_TOKEN_KEY) ?? undefined,
		idToken: localStorage.getItem(KC_ID_TOKEN_KEY) ?? undefined,
	};
}

export function hasStoredKeycloakSession(): boolean {
	const { token, refreshToken } = readStoredKeycloakSession();
	return Boolean(token && refreshToken);
}

export function persistKeycloakSession(adapter: {
	token?: string;
	refreshToken?: string;
	idToken?: string;
}): void {
	if (adapter.token) {
		localStorage.setItem(TOKEN_KEY, adapter.token);
	}
	if (adapter.refreshToken) {
		localStorage.setItem(KC_REFRESH_TOKEN_KEY, adapter.refreshToken);
	}
	if (adapter.idToken) {
		localStorage.setItem(KC_ID_TOKEN_KEY, adapter.idToken);
	}
}

export function clearKeycloakSessionStorage(): void {
	localStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(KC_REFRESH_TOKEN_KEY);
	localStorage.removeItem(KC_ID_TOKEN_KEY);
}

export function syncTokenToStorage(token: string | undefined | null): void {
	if (token) {
		localStorage.setItem(TOKEN_KEY, token);
	} else {
		clearKeycloakSessionStorage();
	}
}

export function mapKeycloakUser(claims: KeycloakUserClaims | undefined): {
	email: string;
	fullName: string;
} | null {
	if (!claims) {
		return null;
	}

	const email = claims.email ?? claims.preferred_username ?? '';
	const fromGivenFamily = [claims.given_name, claims.family_name].filter(Boolean).join(' ');
	const fullName =
		claims.fullName || claims.name || fromGivenFamily || claims.preferred_username || email;

	if (!email && !fullName) {
		return null;
	}

	return {
		email,
		fullName: fullName || email,
	};
}
